import QuizLogoHeader from '@/features/quiz/quiz-logo-header'
import { BaseScreenProps } from '@/features/quiz/types'
import { animate, stagger } from 'framer-motion'
import React, { useEffect, useRef } from 'react'
import { splitText } from '@/shared/motion-plus/split-text'
import BottomContinueButton from '@/features/quiz/bottom-continue-button'

type Props = {
  lines: Array<string>
} & BaseScreenProps

const StaggerDuration = 0.05

export default function EDFactsScreen({ lines, onChange, screenId }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)
  const bottomBarDelay =
    lines
      .map((line) => line.split(' ').length)
      .reduce((acc, curr) => acc + curr, 0) *
      StaggerDuration +
    0.2

  useEffect(() => {
    if (!containerRef.current) return

    for (let i = 0; i < lines.length; i++) {
      const { words } = splitText(
        containerRef.current.querySelector(`#line-${i}`)!,
      )

      animate(
        words,
        { opacity: [0, 1], y: [10, 0] },
        {
          type: 'spring',
          duration: 2,
          bounce: 0,
          delay: stagger(StaggerDuration),
        },
      )
    }
  })

  return (
    <>
      <div ref={containerRef}>
        <QuizLogoHeader />
        <div className="mx-auto mt-24 flex max-w-3xl flex-col gap-y-12 text-2xl font-medium leading-normal tracking-tight text-blue-700 sm:text-3xl">
          {lines.map((line, i) => (
            <p key={i} id={`line-${i}`}>
              {line}
            </p>
          ))}
        </div>
      </div>

      <BottomContinueButton
        // This ensures that the screen is properly marked.
        onClick={async () =>
          onChange(
            screenId,
            {
              id: screenId,
              type: 'number',
              answer: 1,
            },
            true,
          )
        }
        initial={true}
        show={true}
        buttonContainerProps={{ delay: bottomBarDelay }}
      />
    </>
  )
}
